import Vuex from 'vuex';
/* Modules */
import auth from './auth';
import classifier from './classifier';
import featureRules from './feature-rules';
import matching from './matching';
import ner from './ner';
import notifications from './notifications';
import valueMapping from './value-mapping';


export default new Vuex.Store({
  modules: {
    auth,
    classifier,
    featureRules,
    matching,
    ner,
    notifications,
    valueMapping
  }
})
